module.exports = __webpack_public_path__ + "img/iconGuoBangJianCe.c60683e0.svg";